/* eslint-disable no-multi-assign */
/* eslint-disable consistent-return */
/* eslint-disable react/static-property-placement */
import React, { Component } from 'react';
import _ from 'lodash';
import Promise from 'bluebird';
import initWv, { WebViewerInstance } from '@pdftron/webviewer';
import * as R from 'ramda';
import { handleCreateAddressAnnotation as handleCreateAddress, constants, createNotaryVerbiage, parseName } from '@enotarylog/tag-utils'
import moment from 'moment';
import registerTools from './lib';
import handleAuditTrail from './lib/eventListeners/auditTrails';
import * as pathToImg from './lib/helpers/pathToImage';
import CertPdfModal from './components/CertPdfModal';
import ConfirmationModal from './components/ConfirmationModal';
import VADisclaimerModal from './components/VADisclaimerModal';
import DocSelector from './components/DocSelector';
import wvConfig from './lib/configs/wv';
import callIfDefined from './lib/helpers/callIfDefined';
import AddressPromptModal from './components/templateModals/addressPromptModal';
import { bufferStringToJson } from './utils/bufferStringToJson';
import { checkIfAnySignerRequiredTags } from "@enotarylog/shared";

import {
  cleanRequiredArrow,
  toggleRequiredArrow,
  transformRequiredArrow
} from './lib/helpers/handleRequiredArrows';
import { generateFileFromXFDF } from './lib/helpers/generateFileFromXFDF';

const {
  tagTypes,
  states: { abbrToFull },
  rgbaBlack,
  eNoteSelectedDisabledElements,
  documentCompletionTags,
} = constants;

const license = process.env.NX_PDFTRON_LICENSE;

const handleError = (instance) => (error) => {
  if (error.serverResponse && error.serverResponse.rawResponse) {
    const decodedError = bufferStringToJson(error.serverResponse.rawResponse);

    return instance.showErrorMessage(decodedError.message || error.message);
  }

  return instance.showErrorMessage(error.message);
};

export class Webviewer extends Component {
  static defaultProps = {
    loadedDocs: [],
    // config: wvConfig(),
    signatures: {},
    images: {},
    xfdf: {},
    customSignatureColors: null
  }

  constructor(props) {
    super(props);
    this.viewerRef = React.createRef();
    this.targetRef = React.createRef();
    this.containerRef = React.createRef();
    this.state = {
      certModal: { show: false },
      documentBlobs: {},
      switchDisabled: true,
      confirmationModal: { show: false },
      vaDisclaimer: { show: false },
      processedDocs: [],
      status :false,
      promptModal: {
        isOpen: false,
        customData: null,
      },
    };
    this.notarialCertUploadRef = React.createRef();
  }



  initWebviewer = async (config, viewerRef) => {
    const winstance = this.winstance = await initWv(config, viewerRef);

    winstance.iframeWindow.addEventListener('loaderror', function (err) {
      // Do something with error. eg. instance.showErrorMessage('An error has occurred')
      console.error('an error has occurred', err)
      if (err.message.includes('assertion') || err.message.includes('memory access')) {
        window.location.reload();
      }
    });
    winstance.iframeWindow.addEventListener('error', function (err) {
      // Do something with error. eg. instance.showErrorMessage('An error has occurred')
      console.error('an error has occurred', err)
      if (err.message.includes('assertion') || err.message.includes('memory access')) {
        window.location.reload();
      }
    });


    const prom = new Promise((res) => this.winstance.docViewer.one('ready', (instance) => res(instance)));
    this.winstance.docViewer.trigger('initReady');
    const instance = this.instance = await prom;

    return { winstance, instance };
  }

  componentDidMount = async () => {

    const {
      showToolbar,
      docs = {},
      selectedDoc,
      onDocumentChanged,
      onInit,
      onAddDocLoaded,
      onBlankPagesAdded,
      onAnnotationsLoaded,
      onBlankPagesRemoved,
      user,
      signers,
      runId,
      notary,
      onRemoveAllAnnots,
      onAnnotationAdded,
      onAnnotationUpdated,
      onVaDisclaimerChanged,
      onAnnotationDeleted,
      currentUser,
      nsId,
      loadedDocs,
      xfdf,
      selectedSigner,
      onWidgetUpdated,
      onWidgetDeleted,
      onFieldUpdated,
      onWidgetAdded,
      onLockChanged,
      onAuditTrail,
      bindDocEvents,
      bindEvents,
      onRemoveFormFields,
      onRemoveSignatures,
      onSelectedSignerChanged,
      onJumpToAnnot,
      images,
      toolConfig,
      signatures,
      isAdminUser,
      taggingMode,
      customStyle,
      isReadOnly,
      customSignatureColors,
      authenticate,
      defaultRequiredState = false,
      isIframe = false,
      pdftronServer,
      getSessionStatus = undefined,
      insertLuckyOrange,
      config: propConfig
    } = this.props;

    const isEnote = Object.keys(docs).filter(key => docs[key].isEnote).length > 0

    window.pathToImg = pathToImg;


    const baseConfig = {
      path: '/lib',
      ...wvConfig({
        viewOnly: false,
        isAdminUser: isAdminUser,
        taggingMode: taggingMode || false,
        isEnote
      }),
      ...propConfig,
      css: customStyle || '/wv-configs/webviewer-styles/webviewer.css', // assets/wv-configs/webviewer-styles/webviewer.css
      l: license,
      pdftronServer: pdftronServer,
      config: '/webviewer-configs/vanilla-config.umd.js', // This is auto-generated as changes are made | assets/webviewer-configs/vanilla-config.umd.js
      isAdminUser: isAdminUser,
      forceClientSideInit: true,
      fullAPI: true,
      preloadWorker: 'pdf',
      disableLogs: true,
    };

    const { winstance, instance }= await this.initWebviewer({
      ...baseConfig,
      custom: JSON.stringify({
        ...(baseConfig?.custom || {}),
        insertLuckyOrange,
        license,
      }),
    }, this.viewerRef.current);



    window.winstance = winstance;

    // when ready is fired from public/wv-configs/config.js
    /**
     * @param {WebViewerInstance} instance
     */
    const handleReady = async (instance) => {
      // show/hide toolbar
      if (showToolbar) {
        instance.enableElements(['header']);
      } else {
        instance.disableElements(['header']);
      }

      if (customSignatureColors) {
        if (instance.setSignatureColorOptions) {
          instance.setSignatureColorOptions(customSignatureColors, this.viewerRef.current);
        } else {
          const otherInstance = window.getInstance(this.viewerRef.current);
          if (otherInstance && otherInstance.setSignatureColorOptions) {
            otherInstance.setSignatureColorOptions(customSignatureColors, this.viewerRef.current);
          } else {
            console.error('Unable to access fallback setSignatureColorOptions');
          }
        }
      }

      // FORCE INITIAL SIGNATURE COLOR -- This fixes a bug where color will default to last color from previous session
      instance.docViewer.getTool('AnnotationCreateSignature').setStyles(currentStyle => ({
        StrokeThickness: 1,
        StrokeColor: new instance.Annotations.Color(...rgbaBlack),
        TextColor: new instance.Annotations.Color(...rgbaBlack),
      }));

      instance.hotkeys.off(instance.hotkeys.Keys.Y);
      instance.hotkeys.off(instance.hotkeys.Keys['5']);


      if (isReadOnly) {
        instance.setReadOnly(isReadOnly);
      }

      // instance.annotManager.trigger('setSigners', this.props.signers);
      instance.iframeWindow = winstance.iframeWindow;
      this.instance = window.instance = instance;

      const annotManager = this.annotManager = window.annotManager = window.am = instance.annotManager;
      const docViewer = this.docViewer = window.docViewer = window.dv = instance.docViewer;

      this.instance.setDocs(docs);
      this.instance.setXfdfs(xfdf);
      this.instance.annotManager.trigger('setSigners', signers);

      this.instance.setRunId(runId);

      // initialize custom annotation tools
      await registerTools({
        instance,
        config: {
          ...toolConfig,
          signatures: signatures,
          images: images,
          nsId: nsId,
          docs: docs,
          // We don't want signers seeing the Assign a Signer and Required popups
          popupNames: isAdminUser ? [
            'AssignSigner',
            'SetDateFormat',
            'SetYearFormat',
            'SetStateFormat',
            'SetAddressFormat',
            'SetRequired',
          ] : [],
          defaultRequiredState,
          getSessionStatus,
        },
      });

      annotManager.setCurrentUser(currentUser);
      annotManager.setIsAdminUser(isAdminUser);

      if (_.isFunction(authenticate)) {
        await authenticate();
      }

      // Overwrite client-side permission check method on the annotation manager
      // The default was set to compare the authorName
      // Instead of the authorName, we will compare authorId created from the server
      annotManager.setPermissionCheckCallback((author, annotation) => {
        const currentUser = annotManager.getCurrentUser();
        const isAdmin = annotManager.getIsAdminUser();

        return annotation.authorId === currentUser || annotation.Author === currentUser || isAdmin;
      });

      // when cert modal clicked
      instance.docViewer.on('certModal', this.handleCertModal);

      // add next doc and previous doc keyboard shortcuts for notary
      if (isAdminUser) {
        const enableHotkey = localStorage.getItem('hotkey');

        if (enableHotkey) {
          this.setupHotkeys();
        }
      }

      instance.docViewer.on('confirmationModal', this.handleConfirmationModal);
      // when text prompt annot is clicked
      instance.docViewer.on('openPromptModal', ({ id, CustomData }) => {
        this.setState({
          promptModal: {
            isOpen: true,
            annotId: id,
            customData: CustomData,
          },
        });
      });

      instance.docViewer.on('getCommissionName', (tag) => {
        const notary = this.props.notary;
        let commissionName = notary?.commissionName;
        // if its null then use the notary's first and last name
        if (!commissionName) {
          const notaryUserId = notary?.userId;
          if (user?.id === notaryUserId) {
            commissionName = parseName(user);
          }
        }
        tag.commissionName = commissionName;


        return notary?.commissionName;
      })

      instance.docViewer.on('createNotaryVerbiageAnnotation', (tag) => {
        const tagType = tagTypes.notaryVerbiageTags[tag.CustomData.type].type;
        let notaryVerbiage = '';
        const notary = this.props.notary;

        if (tagType === 'docId') {
          notaryVerbiage = `Document ID: ${this.instance.getDocId()}`;
        } else if (tagType === 'nsId') {
          notaryVerbiage = `Session ID: ${nsId}`;
        } else if (tagType === 'commissionId') {
          // NOTE: notary is being passed in differently between the org and consumer room
          notaryVerbiage = notary?.commissionId;
        } else if (tagType === 'commissionExpiration') {
          notaryVerbiage = moment(notary?.notarySeal?.expirationDate).format('MM/DD/YYYY');
        } else if (tagType === 'notaryCounty') {
          const countyName = this.props.countyName;
          notaryVerbiage = countyName;
        } else if (tagType === 'notaryState') {
          let formattedState = abbrToFull[notary?.notaryStateId];

          if (tag.CustomData.flags.stateFormat === 'Abbr') {
            formattedState = notary?.notaryStateId;
          }

          notaryVerbiage = formattedState;
        } else {
          notaryVerbiage = tagTypes.notaryVerbiageTags[tag.CustomData.type].text;
        }

        createNotaryVerbiage(instance, notaryVerbiage, tag);
      });

      // setup listeners which apply no matter which document is loaded
      instance.docViewer.one('documentLoaded', async () => {

        instance.annotManager.on('auditEvent', onAuditTrail);

        // attach event listeners to docViewer
        docViewer.on('lockChanged', callIfDefined(onLockChanged));

        // bind events that should be bound once
        if (_.isFunction(bindEvents)) {
          await bindEvents({
            ...this.instance,
            selectedDoc: this.instance.getDocId(),
          });
        }

        docViewer.on('removeFormFields', callIfDefined(onRemoveFormFields));
        docViewer.on('deleteOtherDocSignatureItems', (userId, docId, type) => callIfDefined(onRemoveSignatures(userId, docId, type)));

        annotManager.on('selectedSignerChanged', onSelectedSignerChanged);
        annotManager.on('jumpToAnnot', onJumpToAnnot);


        // load signatures if available
        if (signatures?.[currentUser]) {
          await this.instance.loadSignatures(signatures[currentUser]);
        }
      });

      instance.docViewer.setFitMode(instance.docViewer.FitMode.FitWidth);

      // setup listeners which listen for events fired from webviewer
      instance.docViewer.on('documentLoaded', async () => {
        // eslint-disable-next-line no-new
        // new Promise((res) => this.instance.docViewer.trigger('setBlankPages', [this.props.blankPages, () => res()]));
        console.debug('%cdocument loaded', 'font-size:12px; color: green;');

        // if docid not loaded yet then load its xfdf
        if (isAdminUser) {
          await this.loadXfdfs(this.props.loadedDocs);
        }

        if (_.isFunction(onAddDocLoaded)) {
          await onAddDocLoaded(selectedDoc, instance);
        }

        docViewer.on('blankPagesAdded', callIfDefined(onBlankPagesAdded));
        docViewer.on('blankPagesRemoved', callIfDefined(onBlankPagesRemoved));
        if (onRemoveAllAnnots) {
          docViewer.on('removeAllAnnots', () => onRemoveAllAnnots(instance));
        }

        /*
          The 'pageComplete' event is triggered when a page has been completely rendered/rerendered.
          For example: applying zoom to a page would trigger a re-render of the entire page.

          At the moment of the implementation of ticket V2-4413, we are adding red arrows as
          indicators that a tag is required. These arrows are appended as DOM elements. Every time
          a re-render of the page is triggered these DOM elements are removed, so we want to store
          them and re-append them, in this case after zooming in or out.
        */
        docViewer.on(
          'pageComplete',
          (pageIndex) => {
            if (isIframe) {
              const requiredArrowElements = instance.getRequiredArrowElementsByPage(pageIndex);

              // If we had any required arrow elements stored, re-append them to the page.
              if (!_.isEmpty(requiredArrowElements)) {
                const pageContainer = instance.iframeWindow?.document?.getElementById(
                  `pageContainer${pageIndex}`
                );

                const zoom = docViewer.getZoom();

                requiredArrowElements.forEach((elementData) => {
                  const {
                    arrow,
                    arrowVerticalPosition,
                    arrowHorizontalPosition
                  } = transformRequiredArrow(zoom, elementData.annotation);

                  elementData.element.style.left =
                    `${(elementData.left - arrowHorizontalPosition) * zoom}px`;
                  elementData.element.style.top =
                    `${(elementData.top + arrowVerticalPosition) * zoom}px`;
                  elementData.element.innerHTML = arrow;

                  pageContainer.appendChild(elementData.element);
                });
              }
            }
          }
        );

        if (onVaDisclaimerChanged) {
          annotManager.on('vaDisclaimerChanged', (show) => {
            return onVaDisclaimerChanged(instance.getSelectedSigner(), show);
          });

        }

        // add event listeners on annotManager for sending annots upstream
        annotManager.on('annotationAdded', onAnnotationAdded);
        annotManager.on('annotationUpdated', onAnnotationUpdated);
        annotManager.on('annotationDeleted', onAnnotationDeleted);

        /*
          When an annotation is deleted we also have to make sure of removing the required arrow
          from the DOM.

          This needs to be in a separate 'annotationDeleted' event since modifying the one
          immediately above was causing unwanted behaviors.
        */
        annotManager.on('annotationDeleted', (annot) => {
          cleanRequiredArrow(instance, annot.id, annot.pageNumber);
        });

        /*
          This 'annotationSelected' event was added for toggling the red required arrow for
          annotations that have the required property set to true:
          - When the annotation is selected > hide the required arrow.
          - When the annotation is deselected > show the required arrow.
        */
        annotManager.on('annotationSelected', (annotations, action) => {
          if (isIframe) {
            const wasSelected = action === 'selected';

            /*
              Saving the recently selected annotations. We do this since the 'annotationSelected'
              event does not gives us annotation data when deselecting, and there's no other event we
              could use for deselecting.

              There is a 'annotationDeselected' event according to the PDFTron docs, but it doesn't
              seem to work in the version used in this project.

              Having a copy of the most recently selected annotations allows us to do something when
              those annotations are deselected.
            */
            if (wasSelected) {
              /*
                When annotations are grouped we want to save the group together to avoid unwanted
                behaviors with the required arrows.
              */
              const annotationGroup = annotManager.getGroupAnnotations(annotations[0]);
              const annotationsToSave = _.unionBy(annotations, annotationGroup, 'uu');

              instance.setRecentlySelectedAnnots(annotationsToSave);
            }

            /*
              We retrieve the array of recently selected annotations.

              This array will contain the annotations that were 'selected' prior to a particular
              'deselected' action.
            */
            const recentlySelectedAnnotations = instance.getRecentlySelectedAnnots();

            /*
              Going through the annotations and toggling the "required arrow", depending on the
              `action` that was received by the 'annotationSelected' event.
            */
            _.forEach(wasSelected ? annotations : recentlySelectedAnnotations,
              (annot) => {
                const isRequired = annot.CustomData?.flags?.required;

                /*
                  We only toggle the arrows for templates. This avoids showing the arrow when the
                  annotation is executed.
                */
                if (annot.Subject.includes('Template') && !annot.Hidden) {
                  toggleRequiredArrow(instance, annot, wasSelected ? false : isRequired);
                }
              }
            );

            /*
              When deselecting we clear the array of recently selected annotations.

              This is actually not really necessary since that array is overwritten every time an
              annotation is selected, but there were some scenarios in which "old" values in this
              array would be used before the "new" ones were stored, and that was causing unwanted
              behaviors.
            */
            if (!wasSelected) {
              instance.clearRecentlySelectedAnnots();
            }
          }
        });

        /*
          Set a handler that will check if there are any signer required tags in the document and
          trigger a `onValidationStatusChange` event if there should be a change in Validation
          state.
        */
        annotManager.on('onValidationStatusCheck', () => {
          const previousValidationState = instance.getEnableValidations();
          const annotationList = instance?.annotManager?.getAnnotationsList();
          const hasDocumentRequiredParticipantTags = checkIfAnySignerRequiredTags(annotationList);

          if (previousValidationState === hasDocumentRequiredParticipantTags) {
            return;
          }

          instance.annotManager.trigger('onValidationStatusChange');

          instance.setEnableValidations(hasDocumentRequiredParticipantTags);
        });

        // Trigger initial check upon document load to keep document viewer in sync.
        annotManager.trigger('onValidationStatusCheck');

        const getHasNotarySealedAndSigned = () => {
          const annotListed = instance?.annotManager?.getAnnotationsList();
          const notary = instance?.getNotary();
          const notaryId = notary?.userId;
          const filteredAnnots = annotListed.filter(e => {
            return e?.Author === notaryId || e?.Subject === 'NotarySealAnnotation';
          });
          return documentCompletionTags.every(value => {
            return filteredAnnots.find(e => e?.Subject === value);
          });
        }

        const toggleParticipantToolsReadOnly = () => {
          const currentAuthUser = instance?.getCurrentAuthUser();
          const currentlySelectedUser = instance?.getSelectedSigner();

          const isCurrentSigner = currentAuthUser === currentlySelectedUser;

          const isDocumentFinished = getHasNotarySealedAndSigned();

          const annotationList = instance.annotManager.getAnnotationsList();
          const hasRequiredParticipantTags = checkIfAnySignerRequiredTags(annotationList);

          const enoteDocs = _.filter(docs, (doc) => doc.isEnote);

          let foundEnote = -1;

          if (_.size(enoteDocs) > 0) {
            foundEnote = _.findIndex(enoteDocs, (enote) => enote.id === selectedDoc);
          }

          if (isDocumentFinished && hasRequiredParticipantTags) {
            instance.annotManager.setReadOnly(true);

            if (isEnote && foundEnote === -1) {
              instance.disableElements(['signatureToolButton', 'freeTextToolButton']);
            }
          } else {
            if (isCurrentSigner) {
              instance.annotManager.setReadOnly(false);

              if (isEnote && foundEnote === -1) {
                instance.enableElements(['signatureToolButton', 'freeTextToolButton']);
              }
            }
          }
        };

        const updateConsumerToolHeader = (annots, action) => {
          if (!(
            ["add", 'delete'].includes(action) &&
            annots.some(e => ["NotarySealAnnotation", "Signature"].includes(e.Subject))
          )) {
            return;
          }

          const isConsumer = !instance?.annotManager?.getIsAdminUser();

          if (!isConsumer) {
            return;
          }

          toggleParticipantToolsReadOnly();
        };

        // Function used for toggling the participant tools depending on the current state of the session.
        const toggleConsumerControls = () => {
          const isConsumer = !instance?.annotManager?.getIsAdminUser();
          const currentAuthUser = instance?.getCurrentAuthUser();

          if (!isConsumer || !currentAuthUser) {
            return;
          }

          toggleParticipantToolsReadOnly();
        }

        annotManager.on('annotationChanged', updateConsumerToolHeader);
        annotManager.on('selectedUserContextUpdate', toggleConsumerControls);

        instance.annotManager.on('onValidationStatusChange', () => {
          // Call re-apply of lock conditions if a change is made.
          toggleConsumerControls();
        });

        annotManager.on('widgetAdded', onWidgetAdded);
        annotManager.on('widgetUpdated', onWidgetUpdated);
        annotManager.on('widgetDeleted', onWidgetDeleted);
        annotManager.on('fieldUpdated', onFieldUpdated);

        handleAuditTrail()({
          instance,
          config: {
            ...toolConfig,
            signatures: signatures,
            images: images,
            nsId: nsId,
            docs: docs,
          },
        });

        instance.docViewer.trigger('documentLoadedAndReady');
      });

      // detach all listeners
      instance.docViewer.on('documentUnloaded', () => {
        docViewer.off('removeAllAnnots');
        docViewer.off('blankPagesAdded');
        docViewer.off('blankPagesRemoved');
        annotManager.off('annotationAdded');
        annotManager.off('annotationUpdated');
        annotManager.off('annotationDeleted');
        annotManager.off('widgetAdded');
        annotManager.off('widgetUpdated');
        annotManager.off('widgetDeleted');
        annotManager.off('fieldUpdated');
        annotManager.off('vaDisclaimerChanged');

        /* Trigger event to know that the unload has finished. */
        instance.docViewer.trigger('documentUnloadedAndReady');

        /*
          Removing required arrow elements when the document is unloaded. E.g.: When switching from
          one document to another, etc.
        */
        instance.docViewer.trigger('unbindRequiredArrows');
      });

      instance.docViewer.on('unbindRequiredArrows', () => {
        if (isIframe) {
          const requiredArrowElements = instance.getAllRequiredArrowElements();

          if (!_.isEmpty(requiredArrowElements)) {
            Object.entries(requiredArrowElements).map(([pageNumber, arrowElements]) => {
              const pageContainer = instance.iframeWindow?.document?.getElementById(
                `pageContainer${pageNumber}`
              );

              if (pageContainer) {
                _.forEach(arrowElements, ({ element, annotation }) => {
                  if (pageContainer.contains(element)) {
                    pageContainer.removeChild(element);
                    instance.removeRequiredArrowElements(pageNumber, annotation.Id);
                  }
                })
              }
            });
          }
        }
      });

      instance.docViewer.one('annotationsLoaded', () => {
        instance.annotManager.trigger('setSelectedSigner', selectedSigner);
      });

      instance.docViewer.on('annotationsLoaded', async () => {
        console.debug('%cAnnotations Loaded', 'font-size:12px; color: green;');

        // bind events for receiving downstream updates
        if (_.isFunction(bindDocEvents)) {
          console.debug('%cbinding doc events', 'font-size:12px; color: green;');
          await bindDocEvents({
            ...instance,
            selectedDoc: instance.getDocId(),
          });
        }

        // Set the list of signers to assign template fields for.
        instance.annotManager.trigger('setSigners', signers);
        const annotList = instance.annotManager.getAnnotationsList();
        annotList.forEach((annot) => {
          const isSelected = instance.annotManager.isAnnotationSelected(annot);
          if (annot.Subject.includes('Template') && !annot.Hidden && !isSelected) {
            toggleRequiredArrow(instance, annot, annot.CustomData?.flags?.required);
          }
        });

        // NOTE: this if for blurry text fix. If annotation is a freetext, then change the width, redraw and revert the width
        _.chain(annotList)
          .filter((annot) => annot.Subject === 'Free text')
          .map((annot) => {
            annot.Width += 0.2;
            return annot;
          })
          .thru(async (annots) => {
            if (annots.length > 0) {
              await instance.annotManager.drawAnnotationsFromList(annots);
              await instance.annotManager.drawAnnotationsFromList(_.map(annots, (a) => {
                a.Width -= 0.2;
                return a;
              }));
            }
          })
          .value()


        // NOTE: make sure whiteouts and strikeouts are in the back
        instance.annotManager.Yb = instance.annotManager.getAnnotationsList().sort((a, b) => a.Subject === 'WhiteOutAnnotation' ? -1 : a.Subject === 'Strikeout' ? -2 : 0)

        // NOTE: fix issue with text based tags having FillColor.A set to 1 instead of 0.5
        await _.chain(annotList)
          .filter((annot) => _.includes(annot.Subject, 'Template') && annot.FillColor && annot.FillColor.A)
          .map((annot) => {
            annot.FillColor.A = 0.5;
            return annot;
          })
          .thru(async (annots) => (annots.length > 0) ? instance.annotManager.drawAnnotationsFromList(annots) : [])
          .value();

        // Set the currentUser
        // instance.annotManager.trigger('setCurrentUser', this.props.currentUser || this.props.userId);
        instance.annotManager.trigger('updateAnnotationPermission');

        /*
          We used to hide this loading message in the documentLoaded handler but it was moved to
          annotationsLoaded to ensure we can start interacting with the document after the annots
          are properly loaded.
        */
        instance.setCustomInstanceProperty('documentIsLoading', false);
        instance.hideMessage('Loading...');

        /*
          Ensure that document unlocking is performed exclusively when the `docLockedWhileLoading`
          flag in the webviewer instance is true. In other words, only unlock the document if the
          document lock was triggered explicitly by the `loadDocument()` function.
        */
        if (
          this.props.isAdminUser
          && this.instance.getCustomInstanceProperty('docLockedWhileLoading')
        ) {
          instance.setCustomInstanceProperty('docLockedWhileLoading', false);
          instance.docViewer.trigger('setLockStatus', [false]);
        }

        if (onAnnotationsLoaded) {
          await onAnnotationsLoaded(instance);
        }
      });

      instance.docViewer.on('processingDocStart', () => {
        this.setState({ switchDisabled: true });
      });

      let processedDocs = [];
      instance.docViewer.on('processingDocFinished', (docId) => {
        console.debug('processed docId', docId)
        processedDocs = _.uniq([...processedDocs, docId]);
        this.setState({
          switchDisabled: false,
          processedDocs,
        });
      });

      if (docs[selectedDoc]) {
        console.debug('loadDocument from onDocumentLoaded')
        this.setState({ switchDisabled: true });
        await this.loadDocument();
      }
      // if docs have been passed and selectedDoc isn't a valid docId
      else if (Object.keys(docs).length > 0) {
        if (selectedDoc === '-1' || !docs[selectedDoc]) {
          onDocumentChanged({
            ...this.instance,
            newDocId: Object.keys(docs)[0],
          });
        }
      }

      if (onInit) {
        onInit(instance, winstance);
      }
    }

    await handleReady(instance);

  }

  setupHotkeys = () => {
    const instance = this.instance;

    if (!instance) {
      return;
    }

    const triggerNextPage = async () => {
      const docIds = _.keys(this.props.docs);
      const currDocId = this.instance.getDocId();
      const i = _.findIndex(docIds, el => el === currDocId);
      const nextDocId = docIds[Math.abs(i + 1) % docIds.length];
      if (this.state.processedDocs.length >= docIds.length && !this.state.switchDisabled) {
        await this.setState({ switchDisabled: true });
        this.props.onDocumentChanged({
          ...this.instance,
          selectedDoc: this.instance.getDocId(),
          newDocId: nextDocId,
        });
        Promise.delay(1500)
          .then(() => {
            this.setState({ switchDisabled: false });
          })
      }
    };

    const triggerPreviousPage = async () => {
      const docIds = _.keys(this.props.docs);
      const currDocId = this.instance.getDocId();
      const i = _.findIndex(docIds, el => el === currDocId);
      const docIndex = (i - 1 < 0) ? docIds.length - 1 : Math.abs(i - 1) % docIds.length
      const nextDocId = docIds[docIndex];
      if (this.state.processedDocs.length >= docIds.length && !this.state.switchDisabled) {
        await this.setState({ switchDisabled: true });
        this.props.onDocumentChanged({
          ...this.instance,
          selectedDoc: this.instance.getDocId(),
          newDocId: nextDocId,
        });
        Promise.delay(1500)
          .then(() => {
            this.setState({ switchDisabled: false });
          })
      }
    }

    instance.hotkeys.on('alt+shift+n', triggerNextPage);
    instance.hotkeys.Keys.ALT_SHIFT_N = 'alt+shift+n';
    instance.hotkeys.Keys.OPTION_SHIFT_N = 'option+shift+n';
    instance.hotkeys.on('option+shit+n', triggerNextPage);
    instance.hotkeys.on('alt+shift+p', triggerPreviousPage);
    instance.hotkeys.on('option+shift+p', triggerPreviousPage);
    instance.hotkeys.Keys.ALT_SHIFT_P = 'alt+shift+p';
    instance.hotkeys.Keys.OPTION_SHIFT_P = 'option+shift+p';
  }

  handleConfirmationModal = ({ message, onConfirm }) => this.setState({
    confirmationModal: {
      show: true,
      message,
      onConfirm,
    },
  })

  handleCertModal = ({ type, pdf }) => {
    if (type === 'file') {
      return this.notarialCertUploadRef.current.click();
    }

    return this.setState({ certModal: { show: true, pdf } });
  }

  componentWillUnmount = async () => {
    if (_.isFunction(this.props.unbindEvents)) {
      await this.props.unbindEvents();
    }

    if (window.getInstance && this.viewerRef.current) {
      // console.log(this.viewerRef);
      const instance = window.getInstance(this.viewerRef.current);


      if (instance) {
        instance?.docViewer?.trigger('documentUnloaded');
        instance.dispose();
      }
    }
  }

  setVaDisclaimer = (show) => this.setState({ vaDisclaimer: { show } })

  componentDidUpdate = async (prevProps) => {
    if (!this.instance) {
      return;
    }

    if (
      (this.props.notary && !this.instance.getNotary()) ||
      (this.props.notary && !prevProps.notary) ||
      (this.props?.notary && prevProps?.notary && this.props?.notary?.id !== prevProps?.notary?.id)
    ) {
      this.instance.setNotary(this.props.notary);
    }

    const enoteDocs = _.filter(this.props.docs, (doc) => doc.isEnote);

    for (const enote of enoteDocs) {
      if (enote.id === this.props.selectedDoc) {
        this.instance.store.dispatch({
          type: 'CLOSE_SIGNATURE_MODAL',
          payload: { type: 'Signature' }
        })
        this.instance.disableElements(eNoteSelectedDisabledElements);
        this.instance.setToolMode('AnnotationEdit');
        this.instance.setActiveHeaderGroup('default');
      }
      else {
        this.instance.enableElements(eNoteSelectedDisabledElements);
        this.instance.setToolMode('AnnotationEdit');
      }
    }

    // show/hide toolbar
    if (this.props.showToolbar) {
      if(!this.state.status) this.setState({status:true});
      this.instance.enableElements(['header']);
    } else {
      this.instance.disableElements(['header']);
    }

    this.instance.hotkeys.off(this.instance.hotkeys.Keys.Y);
    this.instance.hotkeys.off(this.instance.hotkeys.Keys['5']);

    // selected document has changed. close doc and open new
    if (prevProps.selectedDoc !== this.props.selectedDoc) {
      if (this.props.docs[this.props.selectedDoc]) {
        // unBind any external listeners
        if (_.isFunction(this.props.unbindDocEvents)) {
          console.debug('%cunbinding doc events', 'font-size:12px; color: red;');
          await this.props.unbindDocEvents({
            ...this.instance,
            selectedDoc: this.instance.getDocId(),
          });
        }

        /*
          We reset the previous "required tags signed" state back to false when switching docs.
          This is to avoid unwanted behavior with the toasts we show (for more context see ticket
          V2-4549).
        */
        this.instance.setPrevRequiredTagsSignedState(false);

        return this.loadDocument();
      }

      if (this.props.selectedDoc === '-1') {
        return this.instance.closeDocument();
      }
    }

    // signers list has been updated
    if (prevProps.signers !== this.props.signers) {
      this.instance.annotManager.trigger('setSigners', this.props.signers);
    }

    // selected signer has been changed
    // TODO: move to bindEvents
    if (prevProps.selectedSigner !== this.props.selectedSigner) {
      this.instance.annotManager.trigger('setSelectedSigner', this.props.selectedSigner);
    }

    // if current user changed and not an admin, export consumers signatures
    // load currently selected signer's signature if it exists
    if (prevProps.currentUser !== this.props.currentUser) {
      if (!this.props.isAdminUser) {
        if (prevProps.currentUser !== '-1') {
          const sigs = await this.instance.saveSignatures(prevProps.currentUser);

          if (sigs && this.props.onSaveSignature) {
            await this.props.onSaveSignature(prevProps.currentUser, sigs);
          } else if (!sigs && this.props.onSaveSignature) {
            await this.props.onSaveSignature(prevProps.currentUser, {});
          }

          await this.instance.clearSignatures();
        }

        this.instance.annotManager.setCurrentUser(this.props.currentUser);
      }

      if (
        this.props.signatures?.[this.props.currentUser]
        && this.instance.getLoadedSignaturesOwner() !== this.props.currentUser
      ) {
        await this.instance.loadSignatures(this.props.signatures[this.props.currentUser]);

        /*
          To prevent redundant loading, we store the ID of the latest loaded signature's owner,
          as this user change conditional block may run multiple times concurrently.
        */
        this.instance.setLoadedSignaturesOwner(this.props.currentUser);
      } else {
        if (this.props.currentUser === '-1') {
          this.instance.setLoadedSignaturesOwner('-1');
        }
      }
    }

    if (prevProps.showVaDisclaimer !== this.props.showVaDisclaimer) {
      if (this.props.showVaDisclaimer !== false) {
        this.instance.annotManager.trigger('vaModalOpen', []);
      } else {
        this.instance.annotManager.trigger('vaModalDismissed', []);
      }

      if (this.props.showVaDisclaimer === this.instance.getRunId()) {
        this.setVaDisclaimer(this.props.showVaDisclaimer === this.instance.getRunId());
      } else if (this.state.vaDisclaimer.show === true) {
        this.setVaDisclaimer(false);
      }
    }

    // load non-admin user signatures
    if (prevProps.signatures !== this.props.signatures && !this.props.isAdminUser) {
      if (this.props.signatures?.[this.props.currentUser]) {
        await this.instance.loadSignatures(this.props.signatures[this.props.currentUser]);
      }
    }

    // admin user status changed
    if (prevProps.isAdminUser !== this.props.isAdminUser) {
      this.instance.annotManager.setIsAdminUser(this.props.isAdminUser);
    }

    if (prevProps.xfdf !== this.props.xfdf) {
      if (
        // Sunrise update, validates if the document doesn't has annotations
        // !this.props.docs[this.props.selectedDoc].annotsExists
        this.props.xfdf
        && this.props.xfdf[this.props.selectedDoc]
        && this.props.isAdminUser) {
        await this.loadXfdfs(this.props.loadedDocs);
      }
    }

    /*
     * When the notary stops the session without completing it, it sets the empty modal message on
     * The participants side and hides the document.
    */
    if (prevProps.showDoc !== this.props.showDoc) {
      if (!this.props.showDoc && !this.props.isAdminUser) {
        this.instance.showMessage('');
        this.instance.closeDocument();
      }
    }

  }

  loadDocument = async () => {
    const config = {
      ...wvConfig({
        viewOnly: false,
        isAdminUser: this.props.isAdminUser,
        taggingMode: this.props.taggingMode || false,
      }),
      ...this.props.config,
    };

    if (!this.props.docs || !this.props.docs[this.props.selectedDoc]) {
      return;
    }

    const loadDocFrom = this.props.docs[this.props.selectedDoc].url;

    const customHeaders = _.isString(loadDocFrom) && !_.includes(loadDocFrom, window.location.host) ? {} : {
      Authorization: (_.isFunction(this.props.getToken)) ? `Bearer ${this.props.getToken()}` : `Bearer ${this.props.token}`
    };

    let blob;

    /*
      If loading from a document preview (E.g.: the signer side preview), we want to load a flattened
      doc through `getFileData()`.
    */
    if (this.props.isDocumentPreview) {
      blob = await this.loadFlattenedDocument(loadDocFrom, customHeaders);
    }

    /*
      This flag is used to now if the document is loading or not. This value changes in the
      `documentLoaded` event listener.
    */
    this.instance.setCustomInstanceProperty('documentIsLoading', true);

    /*
      Check whether document locking is necessary during the loading process.

      If the document is currently unlocked and a document load is initiated, lock the document.
      Subsequently, set the `docLockedWhileLoading` flag in the webviewer instance to true. This flag
      serves as an indicator that the document lock was triggered specifically by the document load.

      It is essential to avoid trying to lock the document here if the lock was already initiated by
      a different action, such as the notary clicking the Signer Page Lock checkbox.
    */
    if (this.props.isAdminUser && !this.instance.getLock()) {
      this.instance.setCustomInstanceProperty('docLockedWhileLoading', true);
      this.instance.docViewer.trigger('setLockStatus', [true]);
    }

    return this.instance.loadDocument(blob || loadDocFrom, {
      docId: this.props.selectedDoc,
      xfdf: this.props.xfdf[this.props.selectedDoc],
      fullAPI: config.fullAPI,
      pdftronServer: this.props.pdftronServer,
      filename: this.props.selectedDoc,
      flattenSpecialFields: this.props.flattenSpecialFields,
      l: license,
      extension: 'pdf',
      customHeaders,
      forceClientSideInit: true,
      onError: handleError(this.instance),
    });
  }

  loadXfdfs = async (loadedDocs = []) => {
    if (!this.props.setAnnotations) {
      console.warn('setAnnotations not passed a prop to viewer');
      return;
    }

    if (loadedDocs.length === _.keys(this.props.docs).length) {
      return;
    }
    const parsedAnnots = _.chain(this.props.xfdf)
      .omit(loadedDocs)
      .tap((obj) => {
        const keys = _.keys(obj);
        if (keys.length > 0) {
          console.debug(`%cLoading XFDF for doc ids ${keys.join(',')}`, 'font-size: 12px; color: red;');
        } else {
          console.debug(`%cNot Loading XFDF`, 'font-size: 12px; color: red;');
        }
      })
      .mapValues((xfdf, docId) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(xfdf, 'application/xml');
        const annots = doc.querySelector('annots');
        if (!annots) {
          console.warn('no annots found in xfdf', xfdf);
          return [];
        }

        const annotationObjs = _.map(Array.from(annots.children), (annot) => {
          const tcd = annot.querySelector('trn-custom-data');
          let required;
          let dateFormat;

          if (tcd) {
            const bytes = tcd.getAttribute('bytes');
            try {
              const customData = JSON.parse(bytes);
              required = _.get(customData, 'flags.required');
              dateFormat = _.get(customData, 'flags.dateFormat');
            } catch(err) {
              console.warn('failed to parsed trn-custom-data bytes attribute');
            }
          }
          const annotCmd = `<?xml version="1.0" encoding="UTF-8" ?><xfdf xmlns="http://ns.adobe.com/xfdf/" xml:space="preserve"><fields /><add>${annot.outerHTML}</add><modify /><delete /></xfdf>`;
          return _.pickBy({
            xfdf: annotCmd,
            id: annot.getAttribute('name'),
            authorId: this.props.notary.id,
            docId,
            subject: annot.getAttribute('subject'),
            createdAt: Date.now(),
            updatedAt: Date.now(),
            required,
            dateFormat
          }, _.identity)
        });

        return annotationObjs;
      })
      .values()
      .flatten()
      .keyBy('id')
      .value()

    await this.props.setAnnotations(parsedAnnots, true);
    if (this.props.setDocsLoaded) {
      const docIds = _.keys(this.props.docs);
      return this.props.setDocsLoaded(docIds)
    }

  }

  loadFlattenedDocument = async (source, customHeaders) => {
    const doc = await this.instance.CoreControls.createDocument(source, {
      l: license,
      extension: 'pdf',
      customHeaders,
    });

    const data = await doc.getFileData({ flatten: true });
    const arr = new Uint8Array(data);

    return new File([arr], { type: 'application/pdf' });
  }

  render() {
    const isEnote = Object.keys(this.props.docs).filter(key => this.props.docs[key].isEnote).length > 0;
    const config = {
      ...wvConfig({
        viewOnly: false,
        isAdminUser: this.props.isAdminUser,
        taggingMode: this.props.taggingMode || false,
        isEnote,
      }),
      ...this.props.config,
    };

    return (
      <>
        {
          this.props.isAdminUser && this.props.onDocumentChanged && (
            <DocSelector
              docs={this.props.docs}
              disabled={
                this.state.switchDisabled
                || this.props.switchDisabled
                || this.props.updatingXfdf
              }
              processedDocs={_.difference(this.state.processedDocs, this.state.loadingDocs)}
              selectedDoc={this.props.selectedDoc}
              className='doc-selector'
              status={this.state.status}
              onChange={async (newDocId) => {
                if (!this.instance) return;

                // sunrise update, upload the document to the secondary storage
                // obtain the file with the annotations
                const document = this.instance.docViewer.getDocument();

                if (document) {
                  this.instance.showMessage('Loading...');

                  // upload the xfdf to the secondary storage and tell api to merge xfdf with the pdf
                  const docId = this.instance.getDocId();
                  const { uploadUrl } = this.props.docs[docId];

                  if (uploadUrl) {
                    const file = await generateFileFromXFDF(this.instance, docId);

                    this.setState({
                      loadingDocs: _.uniq([...(this.state.loadingDocs || []), docId])
                    }, async () => {
                      /*
                        Trigger the `updatingXfdf` event to signal that the <DocSelector />
                        component started uploading the XFDF file to the secondary storage.
                      */
                      this.instance.docViewer.trigger('updatingXfdf', { updating: true });

                      try {
                        await this.props.uploadToGcs(
                          uploadUrl,
                          file,
                          'application/xml',
                          docId
                        );

                        this.instance.docViewer.trigger('updatingXfdf', { updating: false });

                        this.setState({
                          loadingDocs: _.without(this.state.loadingDocs, docId)
                        });
                      } catch (error) {
                        console.error(
                          'The attempt to upload the updated xfdf and merge it with its corresponding PDF file has failed.'
                        );
                      }
                    });
                  }
                }

                return this.props.onDocumentChanged({
                  ...this.instance,
                  selectedDoc: this.instance.getDocId(),
                  newDocId,
                });
              }}
            />
          )
        }

        <div
          style={{
            height: this.props.height || '100%',
            visibility: this.props.visibility || 'visible',
          }}
          data-testid='webviewer-container'
          className='webviewer-container'
          ref={this.viewerRef}
        />

        <input
          ref={this.notarialCertUploadRef}
          type='file'
          style={{ display: 'none' }}
          accept='image/*,.pdf'
          onChange={(e) => this.setState({ certModal: { show: true, type: 'file', pdf: e.target.files[0] } })}
        />

        <ConfirmationModal
          show={this.state.confirmationModal.show}
          message={this.state.confirmationModal.message}
          onHide={() => this.setState({ confirmationModal: { show: false } })}
          onSubmit={() => {
            this.instance.docViewer.trigger(this.state.confirmationModal.onConfirm);

            return this.setState({ confirmationModal: { show: false } });
          }}
        />

        <CertPdfModal
          show={this.state.certModal.show}
          pdf={this.state.certModal.pdf}
          onHide={() => {
            this.notarialCertUploadRef.current.value = '';// clear input so onchange always fires
            this.setState({ certModal: { show: false } });
          }}
          pdftronServer={this.props.pdftronServer}
          pdftronLicense={config.l}
          currentUser={this.props.currentUser}
          signatures={this.props.signatures}
          onSubmit={({ img, dataUrl }) => {
            this.instance.setCertPdf({ img, dataUrl });
            this.instance.setToolMode('NotaryCertTool');
            this.notarialCertUploadRef.current.value = '';// clear input so onchange always fires
            this.setState({ certModal: { show: false } });
          }}
        />

        <VADisclaimerModal
          show={this.state.vaDisclaimer.show}
          onAccept={() => this.props.onVADisclaimerSubmit(true)}
          onReject={() => this.props.onVADisclaimerSubmit(false)}
        />

        {this.state.promptModal.isOpen && R.includes(this.state.promptModal.customData.type, R.keys(tagTypes.addressTags)) && (
          <AddressPromptModal
            show={this.state.promptModal.isOpen}
            notary={this.props.notary}
            signerId={this.props.selectedSigner}
            onHide={() => this.setState({ promptModal: { isOpen: false } })}
            annotCustomData={this.state.promptModal.customData}
            currentUser={this.instance.getSignerById(this.props.selectedSigner)}
            onSubmit={async (addressInfo) => {
              handleCreateAddress(this.instance,
                addressInfo,
                await this.instance.annotManager.getAnnotationById(this.state.promptModal.annotId),
                this.state.promptModal.customData.type);
              this.setState({ promptModal: { isOpen: false, customData: null } });
            }}
          />
        )}
      </>
    );
  }
}

export default Webviewer;
